import { atlasReducer } from './atlas-reducer';
import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = composeEnhancers(applyMiddleware(thunk))(createStore)(
  atlasReducer
);

export { store };
